import { useCallback, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";

export function useQueryParam(name, setter, fallback = "") {
  const [params] = useSearchParams();
  const v = params.get(name);
  useEffect(() => {
    setter(v === null ? fallback : v);
  }, [v, setter, fallback]);
}

export function useLoad(fetcher, deps = []) {
  const [data, setData] = useState(null);
  const seq = useRef(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const reload = useCallback(async () => {
    const my = ++seq.current;
    try {
      const res = await fetcher();
      if (my === seq.current) setData(res);
    } catch (e) {
      if (my === seq.current) toast.error(errMsg(e));
    }
  }, deps);
  useEffect(() => {
    reload();
  }, [reload]);
  return [data, reload];
}
